const PREFIX = 'domains_search_suite.anon_storefront_results.optimizations.pricing_perception';
const ANONYMOUS = {
  priceLabel: `${PREFIX}.price.first_year_with_3yr_term`,
  priceTooltip: `${PREFIX}.price.first_year_with_3yr_term.tooltip`,
  noteTwoYears: `${PREFIX}.badge.two_years_free_with_plan`,
  noteFirstYear: `${PREFIX}.badge.free_with_plan`,
  cardTwoYears: `${PREFIX}.card.two_years_free`,
  cardFirstYear: `${PREFIX}.card.first_year_free`,
  banner: `${PREFIX}.banner`
};
const BUSINESS_MANAGER = {
  priceLabel: `${PREFIX}.price.first_year_with_3yr_term`,
  priceTooltip: `${PREFIX}.price.first_year_with_3yr_term.tooltip`,
  noteTwoYears: `${PREFIX}.business_manager.badge.two_years_free_with_plan`,
  noteFirstYear: `${PREFIX}.business_manager.badge.free_with_plan`,
  cardTwoYears: `${PREFIX}.business_manager.card.two_years_free`,
  cardFirstYear: `${PREFIX}.business_manager.badge.free_with_plan`,
  banner: `${PREFIX}.business_manager.banner`
};
export const PERCEPTION_CONTENT = {
  anonymous: ANONYMOUS,
  businessManager: BUSINESS_MANAGER
};
//# sourceMappingURL=perceptionContent.js.map